import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-116fe26b")

_pushScopeId("data-v-116fe26b")
const _hoisted_1 = { class: "features" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Carousel = _resolveComponent("Carousel")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Carousel, { features: _ctx.features }, null, 8, ["features"])
  ]))
})